import { render, staticRenderFns } from "./UiBreadcrumbs.vue?vue&type=template&id=01c9cc35&"
import script from "./UiBreadcrumbs.vue?vue&type=script&lang=js&"
export * from "./UiBreadcrumbs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports